import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { navigationAfterLogin } from '../helpers/login';
import { AuthService } from '../services/auth.service';

export const homeGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const user = authService.currentUser();

  if (!authService.isAuthenticated() || !user) {
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl: '/' },
    });
  }

  return router.parseUrl(navigationAfterLogin(user.roles));
};
